


export function createUserGroupList(groups) {
    return groups.map(group => group.name)
}

export function checkIfUserHasGroup(userGroups = [], searchGroups = []) {
    return userGroups.some(group => searchGroups.includes(group))
}